import React, { useState } from 'react'
import { Breadcrumb, Button, Card, Col, Flex, Row, Space, Table, Tag, Typography } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { profData } from '../../../Data';

const { Text } = Typography
const SingleViewPro = () => {
    let { proId } = useParams()
    const navigate = useNavigate() 
    const singleData = profData?.find((fin)=> fin.id === proId)

    console.log('Data',singleData)
    const columns = [
        {
            title: 'Title',
            dataIndex: 'title',
            width: 150,
        },
        {
            title: 'Detail',
            dataIndex: 'detail',
            width: 150,
        },
    ];
    const data = [
        {
            key: '1',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Full Name</Text>
                <Text>
                    {singleData?.firstName?.charAt(0).toUpperCase() + singleData?.firstName?.slice(1)} {' '}
                    {singleData?.lastName?.charAt(0).toUpperCase() + singleData?.lastName?.slice(1)}
                </Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Business Name</Text>
                <Text>{singleData?.businessname}</Text>
            </Space>,
        },
        {
            key: '2',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Email</Text>
                <Text>{singleData?.email}</Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Contact Number</Text>
                <Text>{singleData?.phoneNo}</Text>
            </Space>,
        },
        {
            key: '3',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Role</Text>
                <Text>{singleData?.role}</Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Age</Text>
                <Text>{singleData?.age}</Text>
            </Space>,
        },
        {
            key: '4',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>City</Text>
                <Text>{singleData?.city}</Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Rating</Text>
                {
                    (()=>{
                        if(singleData?.rate === 1){
                            return(
                                <Space size={2}>
                                <img src='/assets/icons/star-f.png' width={15} />
                                <img src='/assets/icons/star-e.png' width={15} />
                                <img src='/assets/icons/star-e.png' width={15} />
                                <img src='/assets/icons/star-e.png' width={15} />
                                <img src='/assets/icons/star-e.png' width={15} />
                            </Space>
                            );
                        } else if(singleData?.rate === 2){
                            return(
                                <Space size={2}>
                                    <img src='/assets/icons/star-f.png' width={15} />
                                    <img src='/assets/icons/star-f.png' width={15} />
                                    <img src='/assets/icons/star-e.png' width={15} />
                                    <img src='/assets/icons/star-e.png' width={15} />
                                    <img src='/assets/icons/star-e.png' width={15} />
                                </Space>
                            )
                        } else if(singleData?.rate === 3){
                            return(
                                <Space size={2}>
                                    <img src='/assets/icons/star-f.png' width={15} />
                                    <img src='/assets/icons/star-f.png' width={15} />
                                    <img src='/assets/icons/star-f.png' width={15} />
                                    <img src='/assets/icons/star-e.png' width={15} />
                                    <img src='/assets/icons/star-e.png' width={15} />
                                </Space>
                            )
                        } else if(singleData?.rate === 4){
                            return(
                                <Space size={2}>
                                    <img src='/assets/icons/star-f.png' width={15} />
                                    <img src='/assets/icons/star-f.png' width={15} />
                                    <img src='/assets/icons/star-f.png' width={15} />
                                    <img src='/assets/icons/star-f.png' width={15} />
                                    <img src='/assets/icons/star-e.png' width={15} />
                                </Space>
                            )
                        } else {
                            return (
                                <Space size={2}>
                                    <img src='/assets/icons/star-f.png' width={15} />
                                    <img src='/assets/icons/star-f.png' width={15} />
                                    <img src='/assets/icons/star-f.png' width={15} />
                                    <img src='/assets/icons/star-f.png' width={15} />
                                    <img src='/assets/icons/star-f.png' width={15} />
                                </Space>
                            )
                        } 
                    })()}                
            </Space>,
        },
        {
            key: '5',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Emergency Number</Text>
                <Text>{singleData?.emergencyNo}</Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Insurance</Text>
                <Text>{singleData?.insurance}</Text>
            </Space>,
        },
        {
            key: '6',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Emergency Number</Text>
                <Text>{singleData?.emergencyNo}</Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Insurance</Text>
                <Text>{singleData?.insurance}</Text>
            </Space>,
        },
        {
            key: '7',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Worker Experience</Text>
                <Text>{singleData?.expwork} Year{ singleData?.expwork > 1 ? 's' : ''}</Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Skills/Services</Text>
                <Flex gap={5} wrap>
                    {
                        singleData?.services?.map((data)=>
                            <Tag className='brand-text border-brand'>
                                {data}
                            </Tag>
                        )
                    }
                </Flex>
            </Space>,
        },
        {
            key: '8',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Registered Date</Text>
                <Text>
                    {singleData?.regDate}
                </Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Status</Text>
                {
                    singleData?.status === 'Active' ? (
                        <Text className='badge-cs active fs-12'>Active</Text>
                    ) : (
                        <Text className='badge-cs inactive fs-12'>Inactive</Text>
                    )
                }
            </Space>,
        },
    ];

    return (
        <div>
            <Breadcrumb className='mb-3'
                separator=">"
                items={[
                    {
                      title: <Text className='cursor text-gray' onClick={()=>navigate('/professional')}>Professional</Text>,
                    },
                    {
                      title: <Text className='fw-500'>
                        {singleData?.firstName?.charAt(0).toUpperCase() + singleData?.firstName?.slice(1)}{' '}
                        {singleData?.lastName?.charAt(0).toUpperCase() + singleData?.lastName?.slice(1)}
                      </Text>,
                    },
                ]}
            />
            <Card className='shadow-d radius-12 mb-3'>
                <Row gutter={[24, 24]}>
                    <Col span={24}>
                        <Space>
                            <Button className='border0 p-0 bg-transparent' onClick={()=>navigate('/professional')}>
                                <ArrowLeftOutlined />
                            </Button>
                            <Text className='fw-500'>
                                {singleData?.firstName?.charAt(0).toUpperCase() + singleData?.firstName?.slice(1)}{' '}
                                {singleData?.lastName?.charAt(0).toUpperCase() + singleData?.lastName?.slice(1)}
                            </Text>
                            {
                                singleData?.status === 'Active' ? (
                                    <Text className='badge-cs active fs-12'>Active</Text>
                                ) : (
                                    <Text className='badge-cs inactive fs-12'>Inactive</Text>
                                )
                            }
                        </Space>
                    </Col>  
                    <Col span={24}>
                        <Table 
                            size='large'
                            columns={columns} 
                            dataSource={data} 
                            scroll={{x: 1000}}
                            className='pagination'
                            showSorterTooltip={false}
                            rowHoverable={false}
                            showHeader={false}
                            pagination={false}
                            // loading={
                            //     {
                            //         ...TableLoader,
                            //         spinning: loading
                            //     }
                            // }
                        />
                    </Col>
                </Row>
            </Card>
        </div>
    )
}

export { SingleViewPro }
